
import { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, onSnapshot, getDocs, doc, getDoc } from 'firebase/firestore';
import { useAppContext } from '../AppContext';

const useStarWeavers = (dreamWeaveId, nexusId) => {
    const { db, appId } = useAppContext();
    const [weavers, setWeavers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!db || !dreamWeaveId || !appId) {
            setLoading(false);
            return;
        }

        const fetchWeavers = async () => {
            setLoading(true);
            try {
                const contributionsPath = nexusId 
                    ? `artifacts/${appId}/public/data/nexuses/${nexusId}/dreamWeaves/${dreamWeaveId}/contributions` 
                    : `artifacts/${appId}/public/data/dreamWeaves/${dreamWeaveId}/contributions`;
                const q = query(collection(db, contributionsPath));
                const querySnapshot = await getDocs(q);

                const contributionsByUser = {};
                querySnapshot.forEach(doc => {
                    const data = doc.data();
                    if (data.userId) {
                        if (!contributionsByUser[data.userId]) {
                            contributionsByUser[data.userId] = 0;
                        }
                        contributionsByUser[data.userId] += 1; // Or use a more complex metric like souls contributed
                    }
                });

                const sortedUsers = Object.entries(contributionsByUser)
                    .sort(([, a], [, b]) => b - a)
                    .slice(0, 5); // Top 5 weavers

                const weaverPromises = sortedUsers.map(async ([userId, contributionCount]) => {
                    const userDocRef = doc(db, `artifacts/${appId}/public/data/user_profiles`, userId);
                    const userDocSnap = await getDoc(userDocRef);
                    if (userDocSnap.exists()) {
                        return { id: userId, ...userDocSnap.data(), contributionCount };
                    }
                    return null;
                });

                const resolvedWeavers = (await Promise.all(weaverPromises)).filter(Boolean);
                setWeavers(resolvedWeavers);

            } catch (err) {
                console.error("Error fetching star weavers:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchWeavers();

    }, [db, dreamWeaveId, nexusId, appId]);

    return { weavers, loading, error };
};

export default useStarWeavers;
